import { Suspense } from 'react';

import { Container } from '@mantine/core';
import { Outlet } from 'react-router-dom';

import { RouteErrorBoundary } from './RouteErrorBoundary';
import { RouteFallback } from './RouteFallback';

export function NoAuthLayout() {
  return (
    <Container size="sm" style={{ marginTop: '2rem' }}>
      <RouteErrorBoundary>
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </RouteErrorBoundary>
    </Container>
  );
}
